import styled from '@emotion/styled';
import { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

const AUTO_DISMISS_MS = 5000;

const ToastContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  margin-top: 16px;
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: #4cbea4;
`;

const ToastMessage = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.57;
  color: #292929;
`;

interface SuccessToastProps {
  readonly message: string;
  readonly onDismiss: () => void;
}

export function SuccessToast({ message, onDismiss }: SuccessToastProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <ToastContainer role="status" aria-live="polite">
      <IconWrapper>
        <CheckCircle size={20} />
      </IconWrapper>
      <ToastMessage>{message}</ToastMessage>
    </ToastContainer>
  );
}
